import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: '¡Ups! Algo ha ido mal',
  subheader: 'La página que buscas no se ha podido cargar.',
  buttonText: 'Continúa en la página inicial',
}
